/* ============================================================
   カート用サブスク加入オファー
   - snippets/cart-subscription-offer.liquid のバナー内ボタンを処理
   - [data-cart-subscription-add] 押下で /cart/add.js に
     variant id + selling_plan を送り、成功後にカートを再読込する
   - selling_plan は Shopify ネイティブの仕組みのため、Shopify
     Subscriptions 純正 / Mikawaya 等アプリを問わず同一に動作する
   ============================================================ */
(function () {
  'use strict';

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function handleClick(event) {
    var button = event.target.closest('[data-cart-subscription-add]');
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    var sellingPlanId = parseInt(button.getAttribute('data-selling-plan-id'), 10);
    if (!variantId) return;

    var offer = button.closest('[data-cart-subscription-offer]');
    var errorEl = offer ? offer.querySelector('[data-cart-subscription-error]') : null;

    var item = { id: variantId, quantity: 1 };
    if (sellingPlanId) {
      item.selling_plan = sellingPlanId;
    }

    button.setAttribute('aria-busy', 'true');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error((data && data.description) || 'カートに追加できませんでした。');
          }
          return data;
        });
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        button.removeAttribute('aria-busy');
        if (errorEl) {
          errorEl.textContent = error.message || '時間をおいて再度お試しください。';
          errorEl.hidden = false;
        }
      });
  }

  document.addEventListener('click', handleClick);
})();
